import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface AtlasConfig {
  partnerId: string;
  accountId?: string;
  marketId?: string;
  groupPath?: string;
  serviceProviderId: string;
  entitlementId?: string;
  defaultPamReason?: string;
  accessDeniedPath?: string;
}

export const ATLAS_CONFIG_TOKEN = new InjectionToken<Observable<AtlasConfig>>('ATLAS_CONFIG');

export type PamEscapeFn = () => Promise<void>;
export const PAM_ESCAPE_FN = new InjectionToken<PamEscapeFn>('PAM_ESCAPE_FN');

export type NotificationLinkHandler = (link: string) => void;
export const NOTIFICATION_LINK_HANDLER = new InjectionToken<NotificationLinkHandler>('NOTIFICATION_LINK_HANDLER');
